/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ccsl_Export_Header_TitleInputs */

const en_ccsl_export_header_title = /** @type {(inputs: Ccsl_Export_Header_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`TITLE`)
};

const fr_ccsl_export_header_title = /** @type {(inputs: Ccsl_Export_Header_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`TITRE`)
};

const de_ccsl_export_header_title = /** @type {(inputs: Ccsl_Export_Header_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`TITEL`)
};

const it_ccsl_export_header_title = /** @type {(inputs: Ccsl_Export_Header_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`TITOLO`)
};

const ru_ccsl_export_header_title = /** @type {(inputs: Ccsl_Export_Header_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ЗАГОЛОВОК`)
};

const es_ccsl_export_header_title = /** @type {(inputs: Ccsl_Export_Header_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`TÍTULO`)
};

const zh_cn2_ccsl_export_header_title = /** @type {(inputs: Ccsl_Export_Header_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`标题`)
};

const ja_ccsl_export_header_title = /** @type {(inputs: Ccsl_Export_Header_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`タイトル`)
};

const hi_ccsl_export_header_title = /** @type {(inputs: Ccsl_Export_Header_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`शीर्षक`)
};

const pt_pt2_ccsl_export_header_title = /** @type {(inputs: Ccsl_Export_Header_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`TÍTULO`)
};

/**
* | output |
* | --- |
* | "TITLE" |
*
* @param {Ccsl_Export_Header_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const ccsl_export_header_title = /** @type {((inputs?: Ccsl_Export_Header_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ccsl_Export_Header_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_ccsl_export_header_title(inputs)
	if (locale === "de") return de_ccsl_export_header_title(inputs)
	if (locale === "it") return it_ccsl_export_header_title(inputs)
	if (locale === "ru") return ru_ccsl_export_header_title(inputs)
	if (locale === "es") return es_ccsl_export_header_title(inputs)
	if (locale === "zh-CN") return zh_cn2_ccsl_export_header_title(inputs)
	if (locale === "ja") return ja_ccsl_export_header_title(inputs)
	if (locale === "hi") return hi_ccsl_export_header_title(inputs)
	if (locale === "pt-PT") return pt_pt2_ccsl_export_header_title(inputs)
	return en_ccsl_export_header_title(inputs)
});